import React from 'react';
import { withRouter } from 'react-router-dom';
import { Level } from 'rbx';
import styled from 'styled-components';
import { ACLSConsumer } from '../../../utils/aclsContext';
import Can from '../../../utils/Can';

const Wrapper = styled.div`
  padding: 0rem 1rem;
  padding-bottom: 1rem;
  background: #ffff;
`;

const Footer = ({
  loading,
  dirty,
  history,
  prev,
  next,
  activeTab,
  values,
  location,
}) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Level.Item>
          <a onClick={() => history.goBack()} className="button is-grey">
            <span className="has-text-weight-semibold">Cancel</span>
          </a>
        </Level.Item>
        {activeTab !== 0 && (
          <Level.Item>
            <button type="button" onClick={prev} className="button is-primary">
              <span>Prev Tab</span>
            </button>
          </Level.Item>
        )}
      </Level.Item>
      <Level.Item align="right">
        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/add-menu-service-setting'
                  ? 'create_service_type_setting'
                  : 'update_service_type_setting'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <Level.Item>
                  <button
                    type="submit"
                    className={`button is-primary ${loading && 'is-loading'}`}
                    disabled={!dirty}
                  >
                    <span className="has-text-weight-semibold">Submit</span>
                  </button>
                </Level.Item>
              )}
            />
          )}
        </ACLSConsumer>
        {values.service_type === 'Delivery' ? (
          <>
            {activeTab !== 2 && (
              <Level.Item>
                <button
                  type="button"
                  onClick={next}
                  className="button is-primary"
                >
                  <span>Next Tab</span>
                </button>
              </Level.Item>
            )}
          </>
        ) : (
          <>
            {activeTab !== 1 && (
              <Level.Item>
                <button
                  type="button"
                  onClick={next}
                  className="button is-primary"
                >
                  <span>Next Tab</span>
                </button>
              </Level.Item>
            )}
          </>
        )}
      </Level.Item>
    </Level>
  </Wrapper>
);

export default withRouter(Footer);
